import { render, staticRenderFns } from "./ConfirmDeliveryAddress.vue?vue&type=template&id=4d9d93c4"
import script from "./ConfirmDeliveryAddress.vue?vue&type=script&lang=js"
export * from "./ConfirmDeliveryAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports